import { createAction, createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { createFetchAction, createSaga, fetchInitialState, fetchReducerActions } from 'store/utils';
import { all, takeLatest } from '@redux-saga/core/effects';
import storage, { deleteCookie, getCookie, keys, setCookie, setSessionCookie } from 'lib/storage';
import * as statisticsApi from 'api/statistics';
import store, { RootState } from 'store';
import { AppActions, AuthActions } from 'store/actionCreators';
import { IUserProfile } from 'lib/types/userTypes';

export const create_statistics_graph = createFetchAction('create_statistics_graph');
export const fetch_statistics_list = createFetchAction('fetch_statistics_list');
export const delete_statistics_graph = createFetchAction('delete_statistics_graph');

interface InitialState {
  createStatistic: object | any;
  fetchStatisticsList: object | any;
  deleteStatistic: object | any;
}

const { ipcRenderer } = window;

const initialState: InitialState = {
  // 최초 랜딩시 storage값 유무 확인
  createStatistic: { ...fetchInitialState },
  fetchStatisticsList: { ...fetchInitialState },
  deleteStatistic: { ...fetchInitialState },
};

const slice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    ...fetchReducerActions(create_statistics_graph, 'createStatistic'),
    ...fetchReducerActions(fetch_statistics_list, 'fetchStatisticsList'),
    ...fetchReducerActions(delete_statistics_graph, 'deleteStatistic'),
  },
});

export const actions: any = slice.actions;

// createSelector

export function* statisticsSaga() {
  yield all([
    takeLatest(
      actions.create_statistics_graph_request,
      createSaga(actions, 'create_statistics_graph', statisticsApi.createStatisticGraph),
    ),
    takeLatest(
      actions.fetch_statistics_list_request,
      createSaga(actions, 'fetch_statistics_list', statisticsApi.fetchStatisticsList),
    ),
    takeLatest(
      actions.delete_statistics_graph_request,
      createSaga(actions, 'delete_statistics_graph', statisticsApi.deleteStatisticGraph),
    ),
  ]);
}

export default slice.reducer;
